export default "__VITE_ASSET__CAgUDwfW__"